import React, { useContext, useEffect, useState } from "react";
import { Grid, TextField } from "@mui/material";
import {
  Controller,
  useFieldArray,
  useFormContext,
} from "react-hook-form";
import { find, get as lodashGet, isEmpty } from "lodash";
import i18next from "i18next";

import { SearchFormInputBloc } from "components/lists-advanced-search/SearchFormInputBloc/SearchFormInputBloc";
import { Context } from "states/Store";
import { ERROR, FieldType } from "services/common/Constants";
import EASelectInput from "components/inputs/EASelectInput";
import EADatePicker from "components/common/EADatePicker";
import { getSourceDataConfigForAccount } from "services/edge/DataHubService";

const getOptions = (dataHub) => {
  const options = [];
  if (dataHub.type === FieldType.BOOLEAN) {
    options.push(
      { value: "true", label: i18next.t("yes") },
      { value: "false", label: i18next.t("no") }
    );
  }
  return options;
};

export function ThirdpartiesSearchDataHub() {
  const formMethods = useFormContext();
  const [state, dispatch] = useContext(Context);
  const [rawSourceData, setRawSourceData] = useState([]);
  const [sourceFields, setSourceFields] = useState([]);


  useEffect(() => {
    if (state.account) {
      (async function fetchData() {
        try {
          const resDataSource = await getSourceDataConfigForAccount(state.account.id, dispatch);
          setRawSourceData(resDataSource.content);
        } catch (e) {
          dispatch({ type: "ALERT", alert: { type: ERROR, msg: e.message } });
          setSourceFields([]);
        }
      })();
    }
  }, [state.account, dispatch]);

  useEffect(() => {
    let list = [];
    let dataHubType = rawSourceData;
    let lang = state.lang;
    for (let opt in dataHubType) {
      let source = dataHubType[opt];
      for (let s of source) {
        let label = s.label[lang] !== undefined ? s.label[lang] : s.label['en'];
        list.push({
          label: opt + " " + label,
          type: s.type,
          id: s.id
        })
      }
    }
    setSourceFields(list);
  }, [rawSourceData, state.lang]);


  const { fields, append } = useFieldArray({
    control: formMethods.control,
    name: "dataHub",
  });

  useEffect(() => {
    if (isEmpty(fields)) {
      for (let s of sourceFields) {
        append({
          id: s.id,
          values: "",
          type: "dataHub",
          name: s.label,
        });
      }
    }
  }, [sourceFields, fields, append]);

  return (
    <>
      {
        fields?.map((field) => {
          let currentFieldIndex;
          currentFieldIndex = fields?.findIndex(
            (sourceField) => sourceField.name === field.name
          );

          const sourceData = find(sourceFields, { label: field.name });
          return (
            sourceData && (
              <Grid item xs={3} key={field.id}>
                <SearchFormInputBloc
                  label={sourceData.label}
                  hasTooltip
                >
                  {(() => {
                    const fieldName = `dataHub.${currentFieldIndex}.values`;
                    switch (sourceData.type) {
                      case FieldType.BOOLEAN:
                        return (
                          <EASelectInput
                            fieldName={fieldName}
                            options={getOptions(sourceData)}
                            defaultOption={i18next.t("all")}
                          />
                        );
                      case FieldType.DATE:
                        return (
                          <Controller
                            control={formMethods.control}
                            name={fieldName}
                            render={({ field }) => (
                              // TODO change this to use a RangePicker instead
                              <EADatePicker
                                {...field}
                                formMethods={formMethods}
                                onlyDate
                                ref={null}
                                sxClass={{
                                  "& input::placeholder": {
                                    color: "#9A9AAF !important",
                                    opacity: 1,
                                  }
                                }}
                              />
                            )}
                          />
                        );
                      default:
                        return (
                          <Controller
                            control={formMethods.control}
                            name={fieldName}
                            /* rules={{
                              maxLength: getAttributeMaxLengthRule(
                                "theValue",
                                ATTRIBUTE_MAX_TEXT_VALUE_LENGTH
                              ),
                              validate: (value) =>
                                validateAttributeInputForType(
                                  sourceData.type,
                                  value
                                ),
                            }} */
                            render={({ field }) => (
                              <TextField
                                {...field}
                                id="sourceData-value-id"
                                variant="outlined"
                                fullWidth
                                placeholder={i18next.t('thirdpartySearch.search')}
                                error={
                                  !!lodashGet(
                                    formMethods.formState.errors,
                                    fieldName
                                  )
                                }
                                helperText={
                                  !!lodashGet(
                                    formMethods.formState.errors,
                                    fieldName
                                  )
                                    ? lodashGet(
                                      formMethods.formState.errors,
                                      fieldName
                                    ).message
                                    : ""
                                }
                              />
                            )}
                          />
                        );
                    }
                  })()}
                </SearchFormInputBloc>
              </Grid>
            )
          );
        })
      }
    </>
  );
}
